import { render, staticRenderFns } from "./TabbedPanel.vue?vue&type=template&id=8a1519e2&"
import script from "./TabbedPanel.vue?vue&type=script&lang=js&"
export * from "./TabbedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports